/**
 * Represents supported sub categories
 *
 * @type {Object<string>}
 */
const SubCategory = {
    VOICE_OVER: 16,
    WEBSITE_DEVELOPMENT: 514
};

export default SubCategory;
